import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = (color) => makeStyles((theme) => {
    let backgroundColor;
    switch (color) {
        case 'primary':
            backgroundColor = theme.palette.customPrimary.main;
            break;
        case 'primary-darkest':
            backgroundColor = theme.palette.customPrimary.dark;
            break;
        case 'primary-light':
            backgroundColor = theme.palette.customPrimary.light;
            break;
        case 'primary-lighter':
            backgroundColor = theme.palette.customPrimary.lighter;
            break;
        case 'rose':
            backgroundColor = theme.palette.customWarning.main;
            break;
        case 'rose-light':
            backgroundColor = theme.palette.customWarning.light;
            break;
        default:
            backgroundColor = theme.palette.customPrimary.main;
            break;
    }
    return {
        root: {
            backgroundColor,
            color: '#fff',
            '&:hover': {
                backgroundColor,
            },
            '&:focus': {
                outline: 'none',
            },
        },
        loading: {
            color: '#fff',
        },
    };
});
const SimpleButton = ({ children = null, icon = '', onClick = () => { }, disabled = false, loading = false, id = '', size = 'medium', variant = 'contained', color = 'primary', className = '', type = 'button', style = {}, ...others }) => {
    const classes = useStyles(color)();
    return (<Button id={id} classes={{ root: classes.root }} variant={variant} size={size} startIcon={icon || null} onClick={onClick} disabled={disabled} type={type} className={className} style={style} {...others}>
      {loading
            ? (<CircularProgress size={21} thickness={5} classes={{ root: classes.loading }}/>)
            : children}
    </Button>);
};
export default SimpleButton;
